import { formatRiskDecimal } from '@/utils';
import { Badge, BadgeProps, Text } from '@cmpsr/components';

type BelowAverageImpactBadgeProps = BadgeProps & {
  impact: number;
};

export default function BelowAverageImpactBadge({ impact, ...props }: BelowAverageImpactBadgeProps) {
  return (
    <Badge w="max-content" backgroundColor="alert-success-default" py="2px" {...props}>
      <Text color="text-success" variant="text-body-bold">
        {formatRiskDecimal(impact)}
      </Text>
    </Badge>
  );
}
